import { createSlice } from '@reduxjs/toolkit';
import { initialState } from './initialState';
import { addOrderToBasket, removeOrderToBasket } from './reducers';

export const draftBasketSlice = createSlice({
  name: 'ordering',
  initialState,
  reducers: {
    addOrderToBasket,
    removeOrderToBasket,
  },
});
